/**
 * HomeButton.js
 *
 * Takes guests from the invite back to the site's home page.
 */

import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";

const HomeButton = () => (
    <Link
        to="/"
        className="mx-auto inline-flex items-center gap-2 rounded-full border-2 px-6 py-2 text-xs font-bold tracking-[0.2em] transition hover:bg-[#1B2A41] hover:text-[#FBF7EF]"
        style={{ borderColor: "#1B2A41" }}
    >
        <Home size={14} aria-hidden="true" /> HOME
    </Link>
);

export default HomeButton;
